// @ts-nocheck
import { Book, Nullable, Project, ProjectUtils, TFile, ImageSizeRequest } from "@brg/api";
import { ImageRequest } from "shared/constants/imageRequest";
import { ComputedDesigner, computeDesigner } from "shared/helpers/computeData";
import { isLowMode } from "shared/helpers/lowmode";
import { ComputedTag, computeTag } from "shared/helpers/types/computed/ComputedTag";
import imgSrc from 'shared/assets/project.svg';
import {executeTypograf} from "../../../../../../../shared/utils/executeTypograf";

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 */
 export interface ComputedBook {
    title: string;
    bookId: string;
    author: ComputedDesigner | undefined;
    bookContexts: string[];
    coAuthors: ComputedDesigner[];
    authorId: string;
    coAuthorIds: string[];
    curators: ComputedDesigner[];
    curatorIds: string[];
    image: string;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    tags: ComputedTag[];
    tagIds?: string[];
    identifier: string;
    status: number;
    likes: number;
    has: boolean;
    isLiked: boolean;
    edited: string;
    publisher: string;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * Здесь есть аргумент imageSize - он отвечает за резоляцию изображений
 *
 * @param book
 * @param imageSize
 */
export function computeBook(book: Nullable<Partial<Book>>, imageSize?: ImageSizeRequest): ComputedBook {
    const image = ProjectUtils.getTitleImageOrUndefined(book as any, isLowMode() ? 'qvga' : imageSize ?? ImageRequest.tile);

    return {
        bookId: book?.bookId ?? 'undefined',
        identifier: book?.bookId ?? 'undefined',
        status: book?.status ?? 0,
        title: executeTypograf(book?.title ?? 'untitled'),
        author: book?.author ? computeDesigner(book?.author) : undefined,
        bookContexts: book?.contexts || [],
        coAuthors: book?.coAuthors ? book.coAuthors.map(computeDesigner) : [],
        curators: book?.curators ? book.curators.map(computeDesigner) : [],
        curatorIds: book?.curatorIds ? book.curatorIds : [],
        authorId: book?.authorId ? book.authorId : "",
        coAuthorIds: book?.coAuthorIds ? book.coAuthorIds : [],
        image: image ?? imgSrc,
        titleImages: book?.titleImages,
        titleImages_en: book?.titleImages_en,
        tags: book?.tags ? book.tags.map(computeTag) : [],
        tagIds: book?.tagIds,
        quCount: book?.quCount ?? 0,
        isQu: book?.isQu ?? false,
        isInSub: book?.isInSub ?? false,
        likes: book?.quCount ?? 0,
        isLiked: book?.isLiked ?? false,
        has: !!book,
        edited: book?.edited ?? "",
        publisher: book?.publisher ?? "",
        canEdit_PartCompetition: !!book?.canEdit_PartCompetition,
        competitions: book?.competitions || []
    };
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param book
 */
export function computeBookMapTile(book?: Nullable<Partial<Book>>): ComputedBook {
    return computeBook(book);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param book
 */
export function computeBookMapImage(book?: Nullable<Partial<Book>>): ComputedBook {
    return computeBook(book, ImageRequest.image);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param book
 * @param imageSize
 */
export function computeManyBooks(
    books: Nullable<Nullable<Partial<Book>>[]>,
    imageSize?: ImageSizeRequest,
): ComputedBook[] {
    return books ? books.map((v) => computeBook(v, imageSize)) : [];
}




 export function computeBookProject(project: Nullable<Partial<Project>>): Partial<Book> {

    return {
        bookId: project?.projectId,                                                                 
        status: project?.status,
        title: executeTypograf(project?.title),
        created: project?.created,
        published: project?.published,
        edited: project?.edited,
        creatorId: project?.creatorId,
        authorId: project?.authorId,
        coAuthorIds: project?.coAuthorIds,
        curatorIds: project?.curatorsIdList,
        competitonsGPA: project?.competitonsGPA,
        competitionGPA: project?.competitionGPA,
        competitions: project?.competitions,
        isAgeRestricted: project?.isAgeRestricted,
        tagIds: project?.tagsID,
        quCount: project?.quCount,
        publisher: project?.publisher,
        bibliographyLink: project?.bibliographyLink,
        contexts: project?.contexts,
        isProtected: project?.isProtected,
        hasGeotag: project?.hasGeotag,
        paymentType: project?.paymentType,
        approvals: project?.approvals,
        author: project?.author,
        coAuthors: project?.coAuthors,
        curators: project?.curators,
        tags: project?.tags,
        tagNames: project?.tagsName,
        isQu: project?.isQu,
        isInSub: project?.isInSub,
        likes: project?.likes,
        isLiked: project?.isLiked,
        isBookmark: project?.isBookmark,
        bookmarkDate: project?.bookmarkDate,
        creator: project?.creator,
        titleImages: project?.titleImages,
        titleImages_en: project?.titleImages_en,
        canEdit_PartCompetition: project?.canEdit_PartCompetition,
        isBook: project?.isBook,
    };
}

export function computeProjectBook(book: Nullable<Partial<Book>>): Partial<Project> {

    return {
        projectId: book?.bookId,
        status: book?.status,
        title: executeTypograf(book?.title),
        created: book?.created,
        published: book?.published,
        edited: book?.edited,
        creatorId: book?.creatorId,
        authorId: book?.authorId,
        coAuthorIds: book?.coAuthorIds,
        curatorsIdList: book?.curatorIds,
        tagsID: book?.tagIds,
        quCount: book?.quCount,
        publisher: book?.publisher,
        bibliographyLink: book?.bibliographyLink,
        contexts: book?.contexts,
        isProtected: book?.isProtected,
        hasGeotag: book?.hasGeotag,
        approvals: book?.approvals,
        author: book?.author,
        coAuthors: book?.coAuthors,
        curators: book?.curators,
        tags: book?.tags,
        tagsName: book?.tagNames,
        isQu: book?.isQu,
        bookmarkDate: book?.bookmarkDate,
        creator: book?.creator,
        titleImages: book?.titleImages,
        titleImages_en: book?.titleImages_en,
        isBook: true
    };
}// @ts-nocheck
import { Book, Nullable, Project, ProjectUtils, TFile, ImageSizeRequest } from "@brg/api";
import { ImageRequest } from "shared/constants/imageRequest";
import { ComputedDesigner, computeDesigner } from "shared/helpers/computeData";
import { isLowMode } from "shared/helpers/lowmode";
import { ComputedTag, computeTag } from "shared/helpers/types/computed/ComputedTag";
import imgSrc from 'shared/assets/project.svg';
import {executeTypograf} from "../../../../../../../shared/utils/executeTypograf";

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 */
 export interface ComputedBook {
    title: string;
    bookId: string;
    author: ComputedDesigner | undefined;
    bookContexts: string[];
    coAuthors: ComputedDesigner[];
    authorId: string;
    coAuthorIds: string[];
    curators: ComputedDesigner[];
    curatorIds: string[];
    image: string;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    tags: ComputedTag[];
    tagIds?: string[];
    identifier: string;
    status: number;
    likes: number;
    has: boolean;
    isLiked: boolean;
    edited: string;
    publisher: string;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * Здесь есть аргумент imageSize - он отвечает за резоляцию изображений
 *
 * @param book
 * @param imageSize
 */
export function computeBook(book: Nullable<Partial<Book>>, imageSize?: ImageSizeRequest): ComputedBook {
    const image = ProjectUtils.getTitleImageOrUndefined(book as any, isLowMode() ? 'qvga' : imageSize ?? ImageRequest.tile);

    return {
        bookId: book?.bookId ?? 'undefined',
        identifier: book?.bookId ?? 'undefined',
        status: book?.status ?? 0,
        title: executeTypograf(book?.title ?? 'untitled'),
        author: book?.author ? computeDesigner(book?.author) : undefined,
        bookContexts: book?.contexts || [],
        coAuthors: book?.coAuthors ? book.coAuthors.map(computeDesigner) : [],
        curators: book?.curators ? book.curators.map(computeDesigner) : [],
        curatorIds: book?.curatorIds ? book.curatorIds : [],
        authorId: book?.authorId ? book.authorId : "",
        coAuthorIds: book?.coAuthorIds ? book.coAuthorIds : [],
        image: image ?? imgSrc,
        titleImages: book?.titleImages,
        titleImages_en: book?.titleImages_en,
        tags: book?.tags ? book.tags.map(computeTag) : [],
        tagIds: book?.tagIds,
        quCount: book?.quCount ?? 0,
        isQu: book?.isQu ?? false,
        isInSub: book?.isInSub ?? false,
        likes: book?.quCount ?? 0,
        isLiked: book?.isLiked ?? false,
        has: !!book,
        edited: book?.edited ?? "",
        publisher: book?.publisher ?? "",
        canEdit_PartCompetition: !!book?.canEdit_PartCompetition,
        competitions: book?.competitions || []
    };
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param book
 */
export function computeBookMapTile(book?: Nullable<Partial<Book>>): ComputedBook {
    return computeBook(book);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param book
 */
export function computeBookMapImage(book?: Nullable<Partial<Book>>): ComputedBook {
    return computeBook(book, ImageRequest.image);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param book
 * @param imageSize
 */
export function computeManyBooks(
    books: Nullable<Nullable<Partial<Book>>[]>,
    imageSize?: ImageSizeRequest,
): ComputedBook[] {
    return books ? books.map((v) => computeBook(v, imageSize)) : [];
}




 export function computeBookProject(project: Nullable<Partial<Project>>): Partial<Book> {

    return {
        bookId: project?.projectId,                                                                 
        status: project?.status,
        title: executeTypograf(project?.title),
        created: project?.created,
        published: project?.published,
        edited: project?.edited,
        creatorId: project?.creatorId,
        authorId: project?.authorId,
        coAuthorIds: project?.coAuthorIds,
        curatorIds: project?.curatorsIdList,
        competitonsGPA: project?.competitonsGPA,
        competitionGPA: project?.competitionGPA,
        competitions: project?.competitions,
        isAgeRestricted: project?.isAgeRestricted,
        tagIds: project?.tagsID,
        quCount: project?.quCount,
        publisher: project?.publisher,
        bibliographyLink: project?.bibliographyLink,
        contexts: project?.contexts,
        isProtected: project?.isProtected,
        hasGeotag: project?.hasGeotag,
        paymentType: project?.paymentType,
        approvals: project?.approvals,
        author: project?.author,
        coAuthors: project?.coAuthors,
        curators: project?.curators,
        tags: project?.tags,
        tagNames: project?.tagsName,
        isQu: project?.isQu,
        isInSub: project?.isInSub,
        likes: project?.likes,
        isLiked: project?.isLiked,
        isBookmark: project?.isBookmark,
        bookmarkDate: project?.bookmarkDate,
        creator: project?.creator,
        titleImages: project?.titleImages,
        titleImages_en: project?.titleImages_en,
        canEdit_PartCompetition: project?.canEdit_PartCompetition,
        isBook: project?.isBook,
    };
}

export function computeProjectBook(book: Nullable<Partial<Book>>): Partial<Project> {

    return {
        projectId: book?.bookId,
        status: book?.status,
        title: executeTypograf(book?.title),
        created: book?.created,
        published: book?.published,
        edited: book?.edited,
        creatorId: book?.creatorId,
        authorId: book?.authorId,
        coAuthorIds: book?.coAuthorIds,
        curatorsIdList: book?.curatorIds,
        tagsID: book?.tagIds,
        quCount: book?.quCount,
        publisher: book?.publisher,
        bibliographyLink: book?.bibliographyLink,
        contexts: book?.contexts,
        isProtected: book?.isProtected,
        hasGeotag: book?.hasGeotag,
        approvals: book?.approvals,
        author: book?.author,
        coAuthors: book?.coAuthors,
        curators: book?.curators,
        tags: book?.tags,
        tagsName: book?.tagNames,
        isQu: book?.isQu,
        bookmarkDate: book?.bookmarkDate,
        creator: book?.creator,
        titleImages: book?.titleImages,
        titleImages_en: book?.titleImages_en,
        isBook: true
    };
}